// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "lang-fr" + "-legacy." + "97cf1df9" + ".js";
};